import { render } from "./WebSkillRankingHeader.vue?vue&type=template&id=489995cf&scoped=true"
import script from "./WebSkillRankingHeader.vue?vue&type=script&lang=js"
export * from "./WebSkillRankingHeader.vue?vue&type=script&lang=js"

import "./WebSkillRankingHeader.vue?vue&type=style&index=0&id=489995cf&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489995cf"]])

export default __exports__